<template>
  <div>
    <div v-if="items" :key="key">
      <div class="checkbox-list" v-if="carouselMode">
        <carousel :navigationEnabled="true" :perPage="2">
          <slide class="slide-main select-item"
                 v-for='colIndex in colsAmount' v-show="getItemIndex(0, colIndex) <= displayLimit"
                 :key="'slide' + colIndex"
                 :style="{width: $store.getters.device.isMobile ? '33.33%' : columnWidthInPixels + 'px', minHeight: 65 * rowsAmount + 'px', 'z-index': colIndex * 100}">
          <span
            v-for="(item, rowIndex) in items.slice((colIndex -1) * rowsAmount, (colIndex -1) * rowsAmount + rowsAmount)"
            v-show="!hideCheck || !item.check">
              <input type="checkbox" class="fct-checkbox" :id="id + getItemIndex(rowIndex, colIndex)"
                     :disabled='isItemDisabled(item)'
                     v-model='item.check' :checked='item.check'>
              <label v-text='item[displayField]' :for="id + getItemIndex(rowIndex, colIndex)"></label>
          </span>
          </slide>
        </carousel>
      </div>
      <div v-else class="checkbox-list"
           :style="{width: scroll ? (columnWidthInPixels * colsAmount) + 'px' : 'auto'}">
        <div class='select-item'
             v-for='colIndex in colsAmount' v-show="getItemIndex(0, colIndex) <= displayLimit"
             :style="{width: fullWidth? '100%' : ($store.getters.device.isMobile ? '50%' : columnWidthInPixels + 'px'), minHeight: 65 * rowsAmount + 'px'}">
          <span :style="{width: $store.getters.device.isMobile ? '100%' : columnWidthInPixels + 'px'}"
                v-for="(item, rowIndex) in items.filter(i => !hideCheck || !i.check).slice((colIndex -1) * rowsAmount, (colIndex -1) * rowsAmount + rowsAmount)">
              <input type="checkbox" class="fct-checkbox" :id="id + getItemIndex(rowIndex, colIndex)"
                     :disabled='isItemDisabled(item)'
                     value="item.check" @input="onCheckboxInput($event.target, item)" :checked='item.check'>
              <label v-text='item[displayField]' :for="id + getItemIndex(rowIndex, colIndex)"></label>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      id: {
        type: String,
        default: ''
      },
      disabled: {
        type: Boolean,
        default: false
      },
      hideCheck: {
        type: Boolean,
        default: false
      },
      fullWidth: {
        type: Boolean,
        default: false
      },
      items: {
        type: Array,
      },
      carouselMode: {
        type: Boolean,
        default: false
      },
      columnWidthInPixels: {
        type: Number
      },
      rowsAmount: {
        type: Number,
        default: 1
      },
      displayField: {
        type: String
      },
      selectLimit: {
        type: Number,
        default: Infinity
      },
      displayLimit: {
        type: Number,
        default: Infinity
      },
      scroll: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        key: 0
      }
    },
    methods: {
      isItemDisabled(item) {
        return this.disabled || this.selectedItems.length === this.selectLimit && !item.check
      },
      getItemIndex(rowIndex, colIndex) {
        return (colIndex * this.rowsAmount) + rowIndex
      },
      onCheckboxInput(target, item) {
        item.check = target.checked
        this.key++
        this.$emit('selectionUpdate', item)
      }
    },
    computed: {
      selectedItems() {
        return this.items.filter(i => i.check)
      },
      colsAmount() {
        return Math.ceil(this.items.length / this.rowsAmount)
      }
    }
  }
</script>

<style lang="scss" scoped>
  .slide-main {
    width: 50%;
    overflow: hidden;
  }

  .checkbox-list {
    .select-item {
      position: relative;
      display: inline-block;
      text-align: left;
      padding-left: 20px;

      > span {
        display: inline-block;
        min-height: 50px;
        vertical-align: text-top;

        label {
          padding: 0 42px;
          text-align: left;
          height: 80px;
          display: table-cell;
          vertical-align: middle;
          position: relative;
          word-break: break-word;

          &:before {
            margin: 0;
            position: absolute;
            top: 50%;
            left: 42px;
            transform: translate(-42px, -50%);
          }
        }
      }
    }
  }
</style>
